import { useEffect } from "react";
import {
  onEventStarting,
  onLeaderboardUpdated,
  onNotificationReceived,
  onRecognitionCreated,
  onUserActivityCreated,
  onLiveEventCommented
} from "@culturehq/client";

import { useProfile } from "app/context";

const useListener = (onSubscribe, onUpdate) => {
  const { profile } = useProfile();

  useEffect(
    () => {
      if (profile.id) {
        let subscription = onSubscribe(onUpdate);

        return () => {
          subscription.unsubscribe();
          subscription = null;
        };
      }

      return undefined;
    },
    [onSubscribe, onUpdate, profile.id]
  );
};

export const useEventStartingListener = onUpdate => (
  useListener(onEventStarting, onUpdate)
);

export const useLeaderboardUpdateListener = onUpdate => (
  useListener(onLeaderboardUpdated, onUpdate)
);

export const useLiveEventCommentedListener = onUpdate => (
  useListener(onLiveEventCommented, onUpdate)
);

export const useNotificationReceivedListener = onUpdate => (
  useListener(onNotificationReceived, onUpdate)
);

export const useRecognitionCreatedListener = onUpdate => (
  useListener(onRecognitionCreated, onUpdate)
);

export const useUserActivityCreatedListener = onUpdate => (
  useListener(onUserActivityCreated, onUpdate)
);
